import React, { useContext, useEffect, useState } from 'react'
import { ContextNotification, severitys } from '../../../App';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Button, Chip, Grid, Stack, TextField } from '@mui/material';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import hotelStructureApi from '../../../api/hotelStructureApi';
import bedReservationApi from '../../../api/bedReservationApi';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"
import CustomDateInput from '../../../Components/CustomDateInput';
import moment from 'jalali-moment'
import passengerInfoApi from '../../../api/passengerInfoApi';

const BedReservationForm = ({ bedId, refreshGrid }) => {

  const { open, setOpen } = useContext(ContextNotification);
  const [submitLoading, setSubmitLoading] = useState(false);
  const schema = yup.object().shape({
    ssn: yup.string().required("کد ملی را وارد نمایید"),
    from: yup.string().required("از تاریخ را وارد نمایید"),
    to: yup.string().required("تا تاریخ را وارد نمایید"),
  });

  const { register, handleSubmit, formState: { errors }, control, watch, resetField } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    setSubmitLoading(true);


    passengerInfoApi.GetPassengerInfoBySSN(data.ssn).then((res) => {
      if (res.data.success) {
        let fromGregorian = null;
        if (watch("from")) {
          let from = new DateObject({
            date: watch("from"),
            calendar: persian,
            locale: persian_fa
          });

          var fromStr = from.year + '/' + from.month.number + '/' + from.day;
          fromGregorian = moment.from(fromStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }

        let toGregorian = null;
        if (watch("to")) {
          let to = new DateObject({
            date: watch("to"),
            calendar: persian,
            locale: persian_fa
          });

          var toStr = to.year + '/' + to.month.number + '/' + to.day;
          toGregorian = moment.from(toStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        }

        const newData = {
          "bedId": bedId,
          "from": fromGregorian,
          "to": toGregorian,
          "passengerId": res.data.data.id
        }
        bedReservationApi.Add(newData).then(res => {
          if (res.data.success) {
            setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
            refreshGrid(true)
            resetForm();
          }
          else {
            setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
          }
        }).catch(err => {
          if (err.response && err.response.data && err.response.data.errors) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
          }
          else if (err.response && err.response.data) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
          }
          else if (err.message) {
            setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
          }
          else {
            setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
          }
        }
        ).finally(() => { setSubmitLoading(false); });
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response && err.response.data && err.response.data.errors) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
      else if (err.response && err.response.data) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
      }
      else if (err.message) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
      }
      else {
        setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false) });


  };
  useEffect(() => {

  }, []);

  const resetForm = () => {
    resetField("from");
    resetField("to");
  }

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: 10 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Controller
              control={control}
              name="from"
              rules={{ required: true }}
              render={({
                field: { onChange, name, value },
                fieldState: { invalid, isDirty },
              }) => (
                <>
                  <DatePicker
                    value={value || ""}
                    onChange={(date) => {
                      onChange(date?.isValid ? date : "");
                    }}
                    format={"YYYY/MM/DD"}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    render={<CustomDateInput label={"از تاریخ"} error={!!errors?.from}
                      helperText={errors?.from?.message} />}
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              control={control}
              name="to"
              rules={{ required: true }}
              render={({
                field: { onChange, name, value },
                fieldState: { invalid, isDirty },
              }) => (
                <>
                  <DatePicker
                    value={value || ""}
                    onChange={(date) => {
                      onChange(date?.isValid ? date : "");
                    }}
                    format={"YYYY/MM/DD"}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                    render={<CustomDateInput label={"تا تاریخ"} error={!!errors?.to}
                      helperText={errors?.to?.message} />}
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField id="code" variant="outlined" {...register("ssn")} fullWidth label="کد ملی" error={!!errors?.ssn}
              helperText={errors?.ssn?.message} />
          </Grid>
          <Grid item md={12}><Button variant='contained' type="submit" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} /> ثبت</Button></Grid>
        </Grid>
      </form>
    </div>
  )
}

export default BedReservationForm